import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import CreateIcon from "icons/CreateIcon"
import Icon from "components/Icon"
import SearchWidget from "components/SearchWidget"
import styles from "./GroupTools.css"
import { ReactFC } from "types"
import { createGroupOptions } from "./create/basics/CreateGroupBasicsPage"
import { HelpContextProvider, useSearchContext, WelcomeToPageButton } from "lib-core"
import { useProfile } from "profile/profile.selectors"

const CreateLink: ReactFC = () => {
  const dispatch = useDispatch()
  const onCreate = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()
    createGroupOptions({ parent: undefined })
    dispatch({ type: "groups/_create/basics" })
  }
  return (
    <Link className={styles.plusicon} onClick={onCreate} to="groups/_create">
      <Icon icon={CreateIcon} />
    </Link>
  )
}

const GroupTools = () => {
  const { filter$ } = useSearchContext()
  const onSearch = ({ filter }) => {
    filter$.emit({ filter })
  }
  const { profile } = useProfile()
  const handleSearch = (filter) => {
    onSearch({ filter })
  }

  const handleCancelSearch = () => {
    onSearch({})
  }

  return (
    <ol className={styles.group_tools}>
      {onSearch ? (
        <li>
          <SearchWidget
            onSearch={handleSearch}
            onCancelSearch={handleCancelSearch}
          />
        </li>
      ) : null}
      <li>
        <CreateLink />
      </li>
      <li>
        <HelpContextProvider page="groups" profile={profile}>
          <WelcomeToPageButton />
        </HelpContextProvider>
      </li>
    </ol>
  )
}

export default GroupTools
